import React from 'react';
import './Loader.css'; // Import plain CSS file

const Loader: React.FC = () => (
  <div id="loader">
    <div className="spinner"></div>
  </div>
);

export default Loader;
